import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import AboutHero from "./components/AboutHero";
import PhilosophySection from "./components/PhilosophySection";
import StorySection from "./components/StorySection";
import InquiryCtaSection from "@/pages/home/components/InquiryCtaSection";

export default function AboutPage() {
  return (
    <main>
      <Navbar />
      <AboutHero />
      <PhilosophySection />
      <StorySection />
      <InquiryCtaSection />
      <Footer />
    </main>
  );
}
